<template>
  <div id="nissan-quiz-thanks-ipad" class="nissan-quiz-screen">
    <div class="timesupTitle">THANKS FOR<br>PLAYING!</div>
  </div>
  </template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ThanksEnd',
  computed: {
    ...mapGetters([
      'config',
      'gameRoomId',
    ]),
  },
};
</script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style  scoped lang="scss">
   @import './../styles/_global.scss';
   @import './../styles/_variables.scss';
  #nissan-quiz-thanks-ipad {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    background-color: #00000040;
  }
  .timesupTitle {
    text-align: center;
    width: 100%;
    font-size: 40px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 320px) {
    .timesupTitle {
      font-size: 30px;
      margin-bottom: 20px;
    }
  }
  </style>
